<template>
  <div>
    <elections-header
      :icon="icon"
      :header="question.header"
      :snippet="question.snippet"
      :resume-download-link="question.url"
      :custom-options="customOptions"
      :has-candidates="hasCandidates"
      :num-positions="question.positions"
      :prevent-proxy-deferrals="preventProxyDeferrals"
      :has-election-ranking="hasElectionRanking"
      :type="question.type"
    />

    <vote-list
      :has-candidates="hasCandidates"
      :votes="votes"
      :nominees="nominees"
      :question-id="questionId"
      :votes-left="votesLeft"
      :custom-options="customOptions"
      :num-positions="question.positions"
      :has-election-ranking="hasElectionRanking"
      :type="type"
    />

    <elections-buttons
      :button-action-type="buttonActionType"
      :is-disabled="hasDuplicateCandidatesInList"
      @show-abstain-modal="showAbstainModal"
      @show-option-modal="showOptionModal"
      @go-next-question="goNextQuestion"
    />
  </div>
</template>

<script>
import ElectionsButtons from './ElectionsButtons.vue';
import ElectionsHeader from './ElectionsHeader.vue';
import VoteList from './ElectionsVoteList.vue';

export default {
  name: 'ElectionsGeneral',
  components: {
    ElectionsButtons,
    ElectionsHeader,
    VoteList
  },
  props: {
    question: {
      type: Object,
      required: true
    },
    questionId: {
      type: [String, Number],
      required: true
    },
    hasCandidates: {
      type: Boolean
    },
    votes: {
      type: Array
    },
    nominees: {
      type: Array
    },
    totalVotes: {
      type: Number
    },
    votesLeft: {
      type: Number,
      required: true
    },
    customOptions: {
      type: Object
    },
    hasDuplicateCandidatesInList: {
      type: Boolean,
      default: false
    },
    preventProxyDeferrals: {
      type: Boolean,
      default: true
    },
    hasElectionRanking: {
      type: Boolean,
      default: false
    },
    type: {
      type: String
    }
  },
  computed: {
    buttonActionType() {
      if (this.votesLeft === 0) {
        return 'next-step';
      } else if (this.votesLeft == this.totalVotes) {
        return 'option-modal';
      } else if (this.votesLeft > 0) {
        if (this.hasElectionRanking) return 'next-step';
        return 'abstain-modal';
      }
    },
    icon() {
      return this.question.type === 'substitute-elections'
        ? 'transfer_within_a_station'
        : 'group';
    }
  },
  methods: {
    showAbstainModal() {
      this.$emit('show-abstain-modal');
    },
    goNextQuestion() {
      this.$emit('go-next-question');
    },
    showOptionModal() {
      this.$emit('show-option-modal');
    }
  }
};
</script>

<style lang="scss" scoped></style>
